// components/TermsModal.tsx
import React from 'react';
import * as S from './TermsModalStyles';
import AlliedLogo from '../../assets/logo-white-allied.png';

interface TermsModalProps {
  isOpen: boolean;
  content: any;
  onAccept: () => void;
  onDecline: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  content,
  onAccept,
  onDecline,
}) => {
  if (!isOpen) return null;

  const hasError = !content?.success;
  const termoHTML =
    content?.data?.textoTermo || '<p>Nenhum termo disponível</p>';

  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalHeader>
          <img
            src={AlliedLogo}
            height={'70px'}
            width="auto"
            alt="Allied Logo"
          />
        </S.ModalHeader>

        <S.ModalContent>
          <S.MainContent>
            {content && hasError ? (
              <p>{content?.errors}</p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: termoHTML }} />
            )}
          </S.MainContent>
        </S.ModalContent>

        <S.ModalFooter>
          <S.DeclineButton onClick={onDecline}>Recusar</S.DeclineButton>
          <S.AcceptButton onClick={onAccept}>Aceito os Termos</S.AcceptButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
};
